const PER_USER_LIMIT_FIELDS = [
  "per_user_limit",
  "per_user_ticket_limit",
  "max_entries_per_user",
  "max_tickets_per_user",
];

const UNTRUSTED_CAP_MARKERS = [
  "per user",
  "per-user",
  "per person",
  "per-person",
  "per customer",
  "per-customer",
  "per entrant",
  "max per",
  "maximum tickets per",
  "tickets per person",
  "tickets per user",
  "tickets per customer",
  "quantity selector",
  "selector cap",
  "quantity max",
  "basket cap",
  "basket limit",
  "purchase cap",
  "purchase limit",
  "order limit",
  "per order",
  "bundle cap",
  "bundle size",
  "package cap",
  "package size",
  "get 500 tickets",
  "get 1000 tickets",
  "get 5000 tickets",
  "llf_high_per_person_fallback",
  "llf_metadata_enter_up_to_fallback",
  "llf_validated_detail_total_cap",
  "llf_per_person_limit",
  "llf_per_order_limit",
  "llf_enter_up_to_limit",
  "llf_quantity_selector_max",
];

const TRUSTED_TOTAL_CAP_MARKERS = [
  "total ticket",
  "total tickets",
  "total entries",
  "total amount of tickets",
  "competition-wide",
  "competition wide",
  "ticket pool",
  "whole competition",
  "tickets available",
  "entries available",
  "tickets remaining",
  "tickets sold",
  "odds 1 in",
  "aria-valuemax",
  "global_maximum_tickets_quantity",
  "maximum_tickets_quantity",
  "dcg_v2",
];

const TRUSTED_LLF_TOTAL_CAP_SOURCES = [
  "llf_availability_progress",
  "llf_sold_progress_total",
  "llf_progress_ratio_total",
  "llf_progress_aria_valuemax",
  "llf_total_tickets_text",
  "llf_rules_total_tickets",
];

const TRUSTED_KILTED_TOTAL_CAP_SOURCES = [
  "kilted_availability_progress",
  "kilted_sold_progress_total",
  "kilted_progress_ratio_total",
  "kilted_progress_aria_valuemax",
  "kilted_total_tickets_text",
  "kilted_rules_total_tickets",
];

const TRUSTED_PAWSOME_TOTAL_CAP_SOURCES = [
  "pawsome_availability_progress",
  "pawsome_sold_progress_total",
  "pawsome_progress_ratio_total",
  "pawsome_progress_aria_valuemax",
  "pawsome_total_tickets_text",
  "pawsome_rules_total_tickets",
];

const TRUSTED_LINCOLNSHIRE_TOTAL_CAP_SOURCES = [
  "lincolnshire_availability_progress",
  "lincolnshire_sold_progress_total",
  "lincolnshire_progress_ratio_total",
  "lincolnshire_progress_aria_valuemax",
  "lincolnshire_total_tickets_text",
  "lincolnshire_rules_total_tickets",
];

const TRUSTED_DRIFT_TOTAL_CAP_SOURCES = [
  "drift_detail_max_entries_text",
];

const TRUSTED_PALLADIUM_TOTAL_CAP_SOURCES = [
  "palladium_detail_max_entries_text",
  "palladium_catalogue_card_exact_progress",
];

const TRUSTED_PRISTINE_TOTAL_CAP_SOURCES = [
  "pristine_detail_max_entries_text",
  "pristine_catalogue_card_exact_progress",
];

const TRUSTED_GIVEAWAYGUYS_TOTAL_CAP_SOURCES = [
  "giveawayguys_detail_product_progress_total",
];

const TRUSTED_UKCC_TOTAL_CAP_SOURCES = [
  "ukcc_api_max_entries",
];

const TRUSTED_ELITE_TOTAL_CAP_SOURCES = [
  "elite_total_entries_text",
  "elite_maximum_entries_text",
];

const TRUSTED_REVCOMPS_TOTAL_CAP_SOURCES = [
  "rev_total_entries_text",
  "rev_detail_total_entries_text",
  "rev_prize_max_tickets_text",
  "rev_ajax_total_entries",
  "rev_ajax_totalentries",
  "rev_ajax_total_tickets",
  "rev_ajax_totaltickets",
  "rev_ajax_total_amount_of_entries",
  "rev_ajax_totalamountofentries",
  "rev_ajax_competition_total_entries",
  "rev_ajax_competitiontotalentries",
  "rev_ajax_number_of_entries",
  "rev_ajax_numberofentries",
  "rev_ajax_number_of_tickets",
  "rev_ajax_numberoftickets",
];

const TRUSTED_SEVENDAYS_TOTAL_CAP_SOURCES = [
  "7days_api_max_entries",
];

const TRUSTED_CLICK_TOTAL_CAP_SOURCES = [
  "click_detail_progress_total_entries",
];

const TRUSTED_STORM_TOTAL_CAP_SOURCES = [
  "storm_detail_max_entries_text",
];

const TRUSTED_CADDY_TOTAL_CAP_SOURCES = [
  "caddy_detail_max_entries_text",
];

const TRUSTED_JAMMY_TOTAL_CAP_SOURCES = [
  "jammy_availability_progress",
  "jammy_sold_progress_total",
  "jammy_progress_ratio_total",
  "jammy_progress_aria_valuemax",
  "jammy_total_tickets_text",
  "jammy_rules_total_tickets",
  "jammy_detail_total_tickets",
];

const TRUSTED_PRIZEPARADISE_TOTAL_CAP_SOURCES = [
  "prizeparadise_detail_max_entries_text",
];

const TRUSTED_BRIGHT_TOTAL_CAP_SOURCES = [
  "bright_detail_max_entries_text",
  "bright_catalogue_card_exact_progress",
];

const TRUSTED_HOTCOMPS_TOTAL_CAP_SOURCES = [
  "hotcomps_availability_progress",
  "hotcomps_sold_progress_total",
  "hotcomps_progress_ratio_total",
  "hotcomps_progress_aria_valuemax",
  "hotcomps_total_tickets_text",
  "hotcomps_rules_total_tickets",
];

const TRUSTED_THATPRIZEGUY_TOTAL_CAP_SOURCES = [
  "thatprizeguy_detail_progress_total",
];

const TRUSTED_SALEXMO_TOTAL_CAP_SOURCES = [
  "salexmo_detail_structured_max_tickets",
];

const TRUSTED_MCKINNEY_TOTAL_CAP_SOURCES = [
  "mckinney_detail_explicit_max_entries",
];

const TRUSTED_ASPIRE_ORDINARY_TOTAL_CAP_SOURCES = [
  "aspire_decoded_variant_max_stock",
  "aspire_detail_total_entries_text",
];

const ASPIRE_AUTODRAW_TOTAL_CAP_SOURCE =
  "aspire_autodraw_variant_max_stock_total_allocation";
const ASPIRE_AUTODRAW_TOTAL_CAP_RULE =
  "aspire_autodraw_max_stock_total_allocation_v1";

const TRUSTED_BOTB_TOTAL_CAP_SOURCES = [
  "botb_detail_page",
  "botb_total_entries_text",
  "botb_explicit_max_tickets",
  "botb_api_structured_total_cap",
];

const UNTRUSTED_LLF_CAP_SOURCES = [
  "llf_high_per_person_fallback",
  "llf_metadata_enter_up_to_fallback",
  "llf_validated_detail_total_cap",
  "llf_per_person_limit",
  "llf_per_order_limit",
  "llf_enter_up_to_limit",
  "llf_quantity_selector_max",
];

const UNTRUSTED_KILTED_CAP_SOURCES = [
  "kilted_high_per_person_fallback",
  "kilted_metadata_enter_up_to_fallback",
  "kilted_validated_detail_total_cap",
  "kilted_per_person_limit",
  "kilted_per_order_limit",
  "kilted_enter_up_to_limit",
  "kilted_quantity_selector_max",
];

const UNTRUSTED_PAWSOME_CAP_SOURCES = [
  "pawsome_detail_per_user_limit",
  "pawsome_enter_up_to_limit",
  "pawsome_per_user_limit",
  "pawsome_quantity_selector_max",
  "pawsome_purchase_limit",
];

const UNTRUSTED_LINCOLNSHIRE_CAP_SOURCES = [
  "lincolnshire_detail_per_user_limit",
  "lincolnshire_enter_up_to_limit",
  "lincolnshire_per_user_limit",
  "lincolnshire_quantity_selector_max",
  "lincolnshire_purchase_limit",
];

const UNTRUSTED_DRIFT_CAP_SOURCES = [
  "drift_detail_per_user_limit",
  "drift_enter_up_to_limit",
  "drift_per_user_limit",
  "drift_quantity_selector_max",
  "drift_purchase_limit",
];

const UNTRUSTED_PALLADIUM_CAP_SOURCES = [
  "palladium_detail_per_user_limit",
  "palladium_enter_up_to_limit",
  "palladium_per_user_limit",
  "palladium_quantity_selector_max",
  "palladium_purchase_limit",
];

const UNTRUSTED_PRISTINE_CAP_SOURCES = [
  "pristine_detail_per_user_limit",
  "pristine_enter_up_to_limit",
  "pristine_per_user_limit",
  "pristine_quantity_selector_max",
  "pristine_purchase_limit",
];

const UNTRUSTED_GIVEAWAYGUYS_CAP_SOURCES = [
  "giveawayguys_detail_per_user_limit",
  "giveawayguys_enter_up_to_limit",
  "giveawayguys_per_user_limit",
  "giveawayguys_quantity_selector_max",
  "giveawayguys_purchase_limit",
];

const UNTRUSTED_UKCC_CAP_SOURCES = [
  "ukcc_api_ticket_limit_per_user",
  "ukcc_per_user_limit",
  "ukcc_quantity_selector_max",
  "ukcc_purchase_limit",
];

const UNTRUSTED_ELITE_CAP_SOURCES = [
  "elite_per_player_limit",
  "elite_quantity_selector_max",
  "elite_bundle_cap",
  "elite_package_cap",
  "elite_purchase_limit",
];

const UNTRUSTED_REVCOMPS_CAP_SOURCES = [
  "rev_per_user_limit",
  "rev_ajax_max_per_person",
  "rev_ajax_maxperperson",
  "rev_ajax_max_per_customer",
  "rev_ajax_maxpercustomer",
  "rev_ajax_maximum_tickets_per_customer",
  "rev_ajax_maximumticketspercustomer",
  "rev_ajax_quantity_max",
  "rev_ajax_quantitymax",
  "rev_quantity_selector_max",
  "rev_bundle_cap",
  "rev_package_cap",
  "rev_purchase_limit",
];

const UNTRUSTED_SEVENDAYS_CAP_SOURCES = [
  "7days_api_per_user_limit",
  "7days_per_user_limit",
  "7days_quantity_selector_max",
  "7days_purchase_limit",
];

const UNTRUSTED_CLICK_CAP_SOURCES = [
  "click_per_user_limit",
  "click_max_entries_per_user",
  "click_quantity_selector_max",
  "click_purchase_limit",
  "click_entry_limit_per_person",
  "click_max_per_person",
];

const UNTRUSTED_STORM_CAP_SOURCES = [
  "storm_detail_per_user_limit",
  "storm_per_user_limit",
  "storm_quantity_selector_max",
  "storm_purchase_limit",
];

const UNTRUSTED_CADDY_CAP_SOURCES = [
  "caddy_detail_per_user_limit",
  "caddy_per_user_limit",
  "caddy_quantity_selector_max",
  "caddy_purchase_limit",
];

const UNTRUSTED_JAMMY_CAP_SOURCES = [
  "jammy_detail_per_player_limit",
  "jammy_per_user_limit",
  "jammy_quantity_selector_max",
  "jammy_purchase_limit",
];

const UNTRUSTED_PRIZEPARADISE_CAP_SOURCES = [
  "prizeparadise_detail_per_user_limit",
  "prizeparadise_per_user_limit",
  "prizeparadise_quantity_selector_max",
  "prizeparadise_purchase_limit",
];

const UNTRUSTED_BRIGHT_CAP_SOURCES = [
  "bright_detail_per_user_limit",
  "bright_per_user_limit",
  "bright_quantity_selector_max",
  "bright_purchase_limit",
];

const UNTRUSTED_HOTCOMPS_CAP_SOURCES = [
  "hotcomps_detail_per_user_limit",
  "hotcomps_enter_up_to_limit",
  "hotcomps_per_user_limit",
  "hotcomps_quantity_selector_max",
  "hotcomps_purchase_limit",
];

const UNTRUSTED_THATPRIZEGUY_CAP_SOURCES = [
  "thatprizeguy_detail_per_user_limit",
  "thatprizeguy_per_user_limit",
  "thatprizeguy_quantity_selector_max",
  "thatprizeguy_purchase_limit",
];

const UNTRUSTED_SALEXMO_CAP_SOURCES = [
  "salexmo_detail_per_user_limit",
  "salexmo_per_user_limit",
  "salexmo_quantity_selector_max",
  "salexmo_purchase_limit",
];

const UNTRUSTED_BOTB_CAP_SOURCES = [
  "botb_per_customer_limit",
  "botb_progress_only",
  "botb_won_left_progress",
  "botb_active_competitions_api_progress",
  "formattedmaxtickets",
  "formattedticketssold",
  "formattedticketsleft",
];

const positiveNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
};

const positiveInt = (value) => {
  const number = positiveNumber(value);
  return number == null ? null : Math.floor(number);
};

export const perUserTicketLimit = (comp = {}) => {
  for (const field of PER_USER_LIMIT_FIELDS) {
    const value = positiveInt(comp?.[field]);
    if (value != null) return value;
  }
  return null;
};

const operatorKey = (comp = {}) =>
  String(
    comp?.operator_key ||
      comp?.source_operator_name ||
      comp?.operator_name ||
      comp?.operator?.name ||
      ""
  )
    .trim()
    .toLowerCase();

const isDcgV2Record = (comp = {}, opKey = "") =>
  comp?.pipeline_version === "v2" &&
  (opKey.includes("dcg") || opKey.includes("dream car giveaways"));

const isLlfRecord = (comp = {}, opKey = "") => {
  if (opKey.includes("llf") || opKey.includes("llf games")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("llfgames.com")
  );
};

const isKiltedRecord = (comp = {}, opKey = "") => {
  if (opKey.includes("kilted") || opKey.includes("kilted competitions")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("kiltedcompetitions.co.uk")
  );
};

const isPawsomeRecord = (comp = {}, opKey = "") => {
  if (opKey.includes("pawsome") || opKey.includes("pawsome competitions")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("pawsomecomps.com")
  );
};

const isLincolnshireRecord = (comp = {}, opKey = "") => {
  if (opKey === "lincolnshire" || opKey.includes("lincolnshire competitions")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("lincolnshire-competitions.co.uk")
  );
};

const isDriftRecord = (comp = {}, opKey = "") => {
  if (opKey === "drift" || opKey.includes("drift competitions")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("driftcompetitions.co.uk")
  );
};

const isPalladiumRecord = (comp = {}, opKey = "") => {
  if (opKey === "palladium" || opKey.includes("palladium competitions")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("palladiumcompetitions.com")
  );
};

const isPristineRecord = (comp = {}, opKey = "") => {
  if (opKey === "pristine" || opKey.includes("pristine competitions")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("pristinecompetitions.co.uk")
  );
};

const isGiveawayGuysRecord = (comp = {}, opKey = "") => {
  if (opKey === "giveawayguys" || opKey.includes("the giveaway guys")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("thegiveawayguys.co.uk")
  );
};

const isUkccRecord = (comp = {}, opKey = "") => {
  if (opKey.includes("ukcc") || opKey.includes("uk carp competitions")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("ukcc.co.uk")
  );
};

const isEliteRecord = (comp = {}, opKey = "") => {
  if (opKey.includes("elite") || opKey.includes("elite competitions")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("elitecompetitions.co.uk")
  );
};

const isRevCompsRecord = (comp = {}, opKey = "") => {
  if (opKey.includes("revcomps") || opKey.includes("rev comps")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("revcomps.com")
  );
};

const isBotbRecord = (comp = {}, opKey = "") => {
  if (opKey.includes("botb")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("botb.com")
  );
};

const isSevendaysRecord = (comp = {}, opKey = "") => {
  if (opKey === "7days" || opKey.includes("7days performance")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("7daysperformance.co.uk")
  );
};

const isClickRecord = (comp = {}, opKey = "") => {
  if (opKey === "click" || opKey.includes("click competitions")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("clickcompetitions.co.uk")
  );
};

const isStormRecord = (comp = {}, opKey = "") => {
  if (opKey === "storm" || opKey.includes("storm competitions")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("stormcompetitions.co.uk")
  );
};

const isCaddyRecord = (comp = {}, opKey = "") => {
  if (opKey === "caddy" || opKey.includes("caddy comps")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("caddycomps.com")
  );
};

const isJammyRecord = (comp = {}, opKey = "") => {
  if (opKey === "jammy") return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("jammy.co.uk")
  );
};

const isPrizeParadiseRecord = (comp = {}, opKey = "") => {
  if (opKey === "prizeparadise" || opKey.includes("prize paradise")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("prizeparadise.co.uk")
  );
};

const isBrightRecord = (comp = {}, opKey = "") => {
  if (opKey === "bright" || opKey.includes("bright competitions")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("brightcompetitions.co.uk")
  );
};

const isHotCompsRecord = (comp = {}, opKey = "") => {
  if (opKey === "hotcomps" || opKey.includes("hot comps")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("hotcomps.com")
  );
};

const isThatPrizeGuyRecord = (comp = {}, opKey = "") => {
  if (opKey === "thatprizeguy" || opKey.includes("that prize guy")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("thatprizeguy.co.uk")
  );
};

const isSalexmoRecord = (comp = {}, opKey = "") => {
  if (opKey === "salexmo") return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("salexmo.co.uk")
  );
};

const isAspireRecord = (comp = {}, opKey = "") => {
  if (opKey === "aspire" || opKey.includes("aspire competitions")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("aspirecomps.co.uk")
  );
};

const isMckinneyRecord = (comp = {}, opKey = "") => {
  if (opKey === "mckinney" || opKey.includes("mckinney competitions")) return true;
  return ["source_competition_url", "competition_url", "operator_url"].some((key) =>
    String(comp?.[key] || "").toLowerCase().includes("mckinneycompetitions.com")
  );
};

const aspireAutoDrawCapTrusted = (comp = {}, cap = null) => {
  const integer = (value, { allowZero = false } = {}) => {
    const number = Number(value);
    if (!Number.isInteger(number)) return null;
    if (allowZero ? number < 0 : number <= 0) return null;
    return number;
  };
  const total = integer(cap);
  const remaining = integer(comp?.remaining_stock, { allowZero: true });
  const current = integer(comp?.current_entries, { allowZero: true });
  const perUser = integer(comp?.per_user_limit);
  return Boolean(
    total != null &&
      remaining != null &&
      current != null &&
      perUser != null &&
      remaining <= total &&
      perUser <= total &&
      current === total - remaining &&
      comp?.aspire_total_cap_trusted === true &&
      comp?.aspire_autodraw_contract_status === "confirmed" &&
      comp?.aspire_product_type_normalised === "autodrawcompetition" &&
      comp?.aspire_variant_type_normalised === "autodrawcompetition" &&
      comp?.max_tickets_rule === ASPIRE_AUTODRAW_TOTAL_CAP_RULE &&
      comp?.current_entries_source === "aspire_autodraw_max_stock_minus_remaining_stock" &&
      comp?.remaining_stock_source === "aspire_decoded_stocklock_stock" &&
      comp?.per_user_limit_source === "aspire_decoded_variant_max_per_person"
  );
};

const botbOddsCompatible = (comp = {}) => {
  const family = String(comp?.botb_competition_family || comp?.botb_family_key || "")
    .trim()
    .toLowerCase();
  const mechanic = String(comp?.competition_mechanic || comp?.botb_mechanic || "")
    .trim()
    .toLowerCase();
  if (["skill_based", "subscriber_or_pass", "subscription"].includes(family)) return false;
  if (["spot_the_ball", "subscription", "botb_pass"].includes(mechanic)) return false;
  if (comp?.closed_signal === true || comp?.sold_out === true) return false;
  return [
    "instant_win_pool",
    "easy_win",
    "win_big",
    "lifestyle",
    "house",
    "free_competition",
  ].includes(family) || comp?.odds_ready === true;
};

const maxTicketEvidenceBlob = (comp = {}) => {
  const pieces = [];
  [
    "max_tickets_source",
    "ticket_cap_source",
    "ticket_cap_evidence",
    "max_tickets_evidence",
    "max_tickets_reason",
  ].forEach((key) => {
    if (comp?.[key] != null && comp[key] !== "") pieces.push(String(comp[key]));
  });

  const source = comp?.field_sources?.max_tickets || {};
  ["source", "evidence_text", "value_source", "reason"].forEach((key) => {
    if (source?.[key] != null && source[key] !== "") pieces.push(String(source[key]));
  });
  return pieces.join(" ").toLowerCase();
};

const hasMarker = (text, markers) => markers.some((marker) => text.includes(marker));

export const totalTicketCapInfo = (comp = {}) => {
  const cap = positiveInt(comp?.total_ticket_cap ?? comp?.max_tickets);
  const perUserLimit = perUserTicketLimit(comp);
  const evidence = maxTicketEvidenceBlob(comp);
  const trustedEvidence = hasMarker(evidence, TRUSTED_TOTAL_CAP_MARKERS);
  const trustedLlfEvidence = hasMarker(evidence, TRUSTED_LLF_TOTAL_CAP_SOURCES);
  const trustedKiltedEvidence = hasMarker(evidence, TRUSTED_KILTED_TOTAL_CAP_SOURCES);
  const trustedPawsomeEvidence = hasMarker(evidence, TRUSTED_PAWSOME_TOTAL_CAP_SOURCES);
  const trustedLincolnshireEvidence = hasMarker(
    evidence,
    TRUSTED_LINCOLNSHIRE_TOTAL_CAP_SOURCES
  );
  const trustedDriftEvidence = hasMarker(
    evidence,
    TRUSTED_DRIFT_TOTAL_CAP_SOURCES
  );
  const trustedPalladiumEvidence = hasMarker(
    evidence,
    TRUSTED_PALLADIUM_TOTAL_CAP_SOURCES
  );
  const trustedPristineEvidence = hasMarker(
    evidence,
    TRUSTED_PRISTINE_TOTAL_CAP_SOURCES
  );
  const trustedGiveawayGuysEvidence = hasMarker(
    evidence,
    TRUSTED_GIVEAWAYGUYS_TOTAL_CAP_SOURCES
  );
  const trustedUkccEvidence = hasMarker(evidence, TRUSTED_UKCC_TOTAL_CAP_SOURCES);
  const trustedEliteEvidence = hasMarker(evidence, TRUSTED_ELITE_TOTAL_CAP_SOURCES);
  const trustedRevCompsEvidence = hasMarker(evidence, TRUSTED_REVCOMPS_TOTAL_CAP_SOURCES);
  const trustedSevendaysEvidence = hasMarker(evidence, TRUSTED_SEVENDAYS_TOTAL_CAP_SOURCES);
  const trustedClickEvidence = hasMarker(evidence, TRUSTED_CLICK_TOTAL_CAP_SOURCES);
  const trustedStormEvidence = hasMarker(evidence, TRUSTED_STORM_TOTAL_CAP_SOURCES);
  const trustedCaddyEvidence = hasMarker(evidence, TRUSTED_CADDY_TOTAL_CAP_SOURCES);
  const trustedJammyEvidence = hasMarker(evidence, TRUSTED_JAMMY_TOTAL_CAP_SOURCES);
  const trustedPrizeParadiseEvidence = hasMarker(
    evidence,
    TRUSTED_PRIZEPARADISE_TOTAL_CAP_SOURCES
  );
  const trustedHotCompsEvidence = hasMarker(evidence, TRUSTED_HOTCOMPS_TOTAL_CAP_SOURCES);
  const trustedThatPrizeGuyEvidence = hasMarker(evidence, TRUSTED_THATPRIZEGUY_TOTAL_CAP_SOURCES);
  const trustedSalexmoEvidence = hasMarker(evidence, TRUSTED_SALEXMO_TOTAL_CAP_SOURCES);
  const trustedBotbEvidence = hasMarker(evidence, TRUSTED_BOTB_TOTAL_CAP_SOURCES);
  const untrustedEvidence = hasMarker(evidence, UNTRUSTED_CAP_MARKERS);
  const untrustedLlfEvidence = hasMarker(evidence, UNTRUSTED_LLF_CAP_SOURCES);
  const untrustedKiltedEvidence = hasMarker(evidence, UNTRUSTED_KILTED_CAP_SOURCES);
  const untrustedPawsomeEvidence = hasMarker(evidence, UNTRUSTED_PAWSOME_CAP_SOURCES);
  const untrustedLincolnshireEvidence = hasMarker(
    evidence,
    UNTRUSTED_LINCOLNSHIRE_CAP_SOURCES
  );
  const untrustedDriftEvidence = hasMarker(
    evidence,
    UNTRUSTED_DRIFT_CAP_SOURCES
  );
  const untrustedPalladiumEvidence = hasMarker(
    evidence,
    UNTRUSTED_PALLADIUM_CAP_SOURCES
  );
  const untrustedPristineEvidence = hasMarker(
    evidence,
    UNTRUSTED_PRISTINE_CAP_SOURCES
  );
  const untrustedGiveawayGuysEvidence = hasMarker(
    evidence,
    UNTRUSTED_GIVEAWAYGUYS_CAP_SOURCES
  );
  const untrustedUkccEvidence = hasMarker(evidence, UNTRUSTED_UKCC_CAP_SOURCES);
  const untrustedEliteEvidence = hasMarker(evidence, UNTRUSTED_ELITE_CAP_SOURCES);
  const untrustedRevCompsEvidence = hasMarker(evidence, UNTRUSTED_REVCOMPS_CAP_SOURCES);
  const untrustedSevendaysEvidence = hasMarker(evidence, UNTRUSTED_SEVENDAYS_CAP_SOURCES);
  const untrustedClickEvidence = hasMarker(evidence, UNTRUSTED_CLICK_CAP_SOURCES);
  const untrustedStormEvidence = hasMarker(evidence, UNTRUSTED_STORM_CAP_SOURCES);
  const untrustedCaddyEvidence = hasMarker(evidence, UNTRUSTED_CADDY_CAP_SOURCES);
  const untrustedJammyEvidence = hasMarker(evidence, UNTRUSTED_JAMMY_CAP_SOURCES);
  const untrustedPrizeParadiseEvidence = hasMarker(
    evidence,
    UNTRUSTED_PRIZEPARADISE_CAP_SOURCES
  );
  const untrustedBrightEvidence = hasMarker(evidence, UNTRUSTED_BRIGHT_CAP_SOURCES);
  const untrustedHotCompsEvidence = hasMarker(evidence, UNTRUSTED_HOTCOMPS_CAP_SOURCES);
  const untrustedThatPrizeGuyEvidence = hasMarker(evidence, UNTRUSTED_THATPRIZEGUY_CAP_SOURCES);
  const untrustedSalexmoEvidence = hasMarker(evidence, UNTRUSTED_SALEXMO_CAP_SOURCES);
  const untrustedBotbEvidence = hasMarker(evidence, UNTRUSTED_BOTB_CAP_SOURCES);
  const ticketsAvailable = positiveInt(comp?.tickets_available);
  const opKey = operatorKey(comp);
  const llfRecord = isLlfRecord(comp, opKey);
  const kiltedRecord = isKiltedRecord(comp, opKey);
  const pawsomeRecord = isPawsomeRecord(comp, opKey);
  const lincolnshireRecord = isLincolnshireRecord(comp, opKey);
  const driftRecord = isDriftRecord(comp, opKey);
  const palladiumRecord = isPalladiumRecord(comp, opKey);
  const pristineRecord = isPristineRecord(comp, opKey);
  const giveawayGuysRecord = isGiveawayGuysRecord(comp, opKey);
  const ukccRecord = isUkccRecord(comp, opKey);
  const eliteRecord = isEliteRecord(comp, opKey);
  const revCompsRecord = isRevCompsRecord(comp, opKey);
  const sevendaysRecord = isSevendaysRecord(comp, opKey);
  const clickRecord = isClickRecord(comp, opKey);
  const stormRecord = isStormRecord(comp, opKey);
  const caddyRecord = isCaddyRecord(comp, opKey);
  const jammyRecord = isJammyRecord(comp, opKey);
  const prizeParadiseRecord = isPrizeParadiseRecord(comp, opKey);
  const brightRecord = isBrightRecord(comp, opKey);
  const hotcompsRecord = isHotCompsRecord(comp, opKey);
  const thatprizeguyRecord = isThatPrizeGuyRecord(comp, opKey);
  const salexmoRecord = isSalexmoRecord(comp, opKey);
  const aspireRecord = isAspireRecord(comp, opKey);
  const mckinneyRecord = isMckinneyRecord(comp, opKey);
  const botbRecord = isBotbRecord(comp, opKey);
  const explicitTotalCap = comp?.total_ticket_cap != null && comp.total_ticket_cap !== "";
  const dcgV2Record = isDcgV2Record(comp, opKey);
  const availabilityBackedTotal = ticketsAvailable != null && cap != null && ticketsAvailable <= cap;

  const base = {
    perUserTicketLimit: perUserLimit,
    ticketCapTrusted: false,
    ticketCapUnclear: true,
  };

  if (cap == null) {
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "missing_total_ticket_cap",
    };
  }
  if (aspireRecord) {
    if (comp?.odds_ready !== true || comp?.budget_odds_eligible !== true) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "aspire_not_published_odds_ready",
      };
    }
    const source = String(comp?.max_tickets_source || "").trim().toLowerCase();
    const ordinaryTrusted =
      comp?.aspire_total_cap_trusted === true &&
      TRUSTED_ASPIRE_ORDINARY_TOTAL_CAP_SOURCES.includes(source);
    const autoDrawTrusted =
      source === ASPIRE_AUTODRAW_TOTAL_CAP_SOURCE &&
      aspireAutoDrawCapTrusted(comp, cap);
    const aspirePerUserLimit = positiveInt(comp?.per_user_limit) ?? perUserLimit;
    if (aspirePerUserLimit != null && cap === aspirePerUserLimit) {
      return {
        ...base,
        perUserTicketLimit: aspirePerUserLimit,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_per_user_limit",
      };
    }
    if (ordinaryTrusted || autoDrawTrusted) {
      return {
        totalTicketCap: cap,
        perUserTicketLimit: aspirePerUserLimit,
        ticketCapTrusted: true,
        ticketCapUnclear: false,
        ticketCapReason: "trusted_aspire_total_ticket_cap",
      };
    }
    return {
      ...base,
      perUserTicketLimit: aspirePerUserLimit,
      totalTicketCap: null,
      ticketCapReason: "aspire_total_cap_unclear",
    };
  }
  if (mckinneyRecord) {
    const source = String(comp?.max_tickets_source || "").trim().toLowerCase();
    const mckinneyPerUserLimit = positiveInt(comp?.per_user_limit) ?? perUserLimit;
    const trusted = Boolean(
      comp?.max_tickets_trusted === true &&
      TRUSTED_MCKINNEY_TOTAL_CAP_SOURCES.includes(source) &&
      String(comp?.max_tickets_evidence || "").trim() &&
      String(comp?.mckinney_exact_identity || "").trim() &&
      comp?.mckinney_standard_odds_supported === true &&
      comp?.ticket_price_trusted === true &&
      String(comp?.ticket_price_currency || "").trim().toUpperCase() === "GBP"
    );
    const mckinneyBase = {
      ...base,
      perUserTicketLimit: mckinneyPerUserLimit,
    };
    if (comp?.odds_ready !== true || comp?.budget_odds_eligible !== true) {
      return {
        ...mckinneyBase,
        totalTicketCap: null,
        ticketCapReason: "mckinney_not_published_odds_ready",
      };
    }
    if (!trusted) {
      return {
        ...mckinneyBase,
        totalTicketCap: null,
        ticketCapReason: "mckinney_total_cap_unclear",
      };
    }
    if (mckinneyPerUserLimit != null && mckinneyPerUserLimit >= cap) {
      return {
        ...mckinneyBase,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_or_below_per_user_limit",
      };
    }
    return {
      totalTicketCap: cap,
      perUserTicketLimit: mckinneyPerUserLimit,
      ticketCapTrusted: true,
      ticketCapUnclear: false,
      ticketCapReason: "trusted_mckinney_total_ticket_cap",
    };
  }
  if (botbRecord) {
    if (!botbOddsCompatible(comp)) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "botb_not_standard_odds_eligible",
      };
    }
    if (untrustedEvidence || untrustedBotbEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_source_is_purchase_limit",
      };
    }
    if (perUserLimit != null && cap === perUserLimit && !trustedBotbEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_per_user_limit",
      };
    }
    if (trustedBotbEvidence) {
      return {
        totalTicketCap: cap,
        perUserTicketLimit: perUserLimit,
        ticketCapTrusted: true,
        ticketCapUnclear: false,
        ticketCapReason: "trusted_botb_total_ticket_cap",
      };
    }
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "botb_total_cap_unclear",
    };
  }
  if (llfRecord) {
    if (untrustedEvidence || untrustedLlfEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_source_is_purchase_limit",
      };
    }
    const llfTrustedTotal = trustedLlfEvidence || explicitTotalCap;
    if (perUserLimit != null && cap === perUserLimit && !llfTrustedTotal) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_per_user_limit",
      };
    }
    if (llfTrustedTotal) {
      return {
        totalTicketCap: cap,
        perUserTicketLimit: perUserLimit,
        ticketCapTrusted: true,
        ticketCapUnclear: false,
        ticketCapReason: "trusted_llf_total_ticket_cap",
      };
    }
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "llf_total_cap_unclear",
    };
  }
  if (kiltedRecord) {
    if (untrustedEvidence || untrustedKiltedEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_source_is_purchase_limit",
      };
    }
    const kiltedTrustedTotal = trustedKiltedEvidence || explicitTotalCap;
    if (perUserLimit != null && cap === perUserLimit && !kiltedTrustedTotal) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_per_user_limit",
      };
    }
    if (kiltedTrustedTotal) {
      return {
        totalTicketCap: cap,
        perUserTicketLimit: perUserLimit,
        ticketCapTrusted: true,
        ticketCapUnclear: false,
        ticketCapReason: "trusted_kilted_total_ticket_cap",
      };
    }
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "kilted_total_cap_unclear",
    };
  }
  if (pawsomeRecord) {
    if (untrustedEvidence || untrustedPawsomeEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_source_is_purchase_limit",
      };
    }
    const pawsomeTrustedTotal = trustedPawsomeEvidence || explicitTotalCap;
    if (perUserLimit != null && cap === perUserLimit && !pawsomeTrustedTotal) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_per_user_limit",
      };
    }
    if (pawsomeTrustedTotal) {
      return {
        totalTicketCap: cap,
        perUserTicketLimit: perUserLimit,
        ticketCapTrusted: true,
        ticketCapUnclear: false,
        ticketCapReason: "trusted_pawsome_total_ticket_cap",
      };
    }
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "pawsome_total_cap_unclear",
    };
  }
  if (lincolnshireRecord) {
    if (untrustedEvidence || untrustedLincolnshireEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_source_is_purchase_limit",
      };
    }
    const lincolnshireTrustedTotal = trustedLincolnshireEvidence || explicitTotalCap;
    if (perUserLimit != null && cap === perUserLimit && !lincolnshireTrustedTotal) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_per_user_limit",
      };
    }
    if (lincolnshireTrustedTotal) {
      return {
        totalTicketCap: cap,
        perUserTicketLimit: perUserLimit,
        ticketCapTrusted: true,
        ticketCapUnclear: false,
        ticketCapReason: "trusted_lincolnshire_total_ticket_cap",
      };
    }
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "lincolnshire_total_cap_unclear",
    };
  }
  if (driftRecord) {
    if (untrustedEvidence || untrustedDriftEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_source_is_purchase_limit",
      };
    }
    const driftTrustedTotal = trustedDriftEvidence || explicitTotalCap;
    if (perUserLimit != null && cap === perUserLimit && !driftTrustedTotal) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_per_user_limit",
      };
    }
    if (driftTrustedTotal) {
      return {
        totalTicketCap: cap,
        perUserTicketLimit: perUserLimit,
        ticketCapTrusted: true,
        ticketCapUnclear: false,
        ticketCapReason: "trusted_drift_total_ticket_cap",
      };
    }
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "drift_total_cap_unclear",
    };
  }
  if (palladiumRecord) {
    if (untrustedEvidence || untrustedPalladiumEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_source_is_purchase_limit",
      };
    }
    const palladiumTrustedTotal = trustedPalladiumEvidence || explicitTotalCap;
    if (perUserLimit != null && cap === perUserLimit && !palladiumTrustedTotal) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_per_user_limit",
      };
    }
    if (palladiumTrustedTotal) {
      return {
        totalTicketCap: cap,
        perUserTicketLimit: perUserLimit,
        ticketCapTrusted: true,
        ticketCapUnclear: false,
        ticketCapReason: "trusted_palladium_total_ticket_cap",
      };
    }
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "palladium_total_cap_unclear",
    };
  }
  if (pristineRecord) {
    if (untrustedEvidence || untrustedPristineEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_source_is_purchase_limit",
      };
    }
    const pristineTrustedTotal = trustedPristineEvidence || explicitTotalCap;
    if (perUserLimit != null && cap === perUserLimit && !pristineTrustedTotal) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_per_user_limit",
      };
    }
    if (pristineTrustedTotal) {
      return {
        totalTicketCap: cap,
        perUserTicketLimit: perUserLimit,
        ticketCapTrusted: true,
        ticketCapUnclear: false,
        ticketCapReason: "trusted_pristine_total_ticket_cap",
      };
    }
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "pristine_total_cap_unclear",
    };
  }
  if (giveawayGuysRecord) {
    const source = String(comp?.max_tickets_source || "").trim().toLowerCase();
    const giveawayGuysPerUserLimit = positiveInt(comp?.per_user_limit) ?? perUserLimit;
    const trusted = Boolean(
      comp?.odds_ready === true
      && comp?.budget_odds_eligible === true
      && comp?.max_tickets_trusted === true
      && TRUSTED_GIVEAWAYGUYS_TOTAL_CAP_SOURCES.includes(source)
      && trustedGiveawayGuysEvidence
      && !untrustedGiveawayGuysEvidence
      && String(comp?.max_tickets_evidence || "").trim()
      && String(comp?.giveawayguys_exact_identity || "").trim()
      && comp?.giveawayguys_standard_odds_supported === true
      && comp?.giveawayguys_awareness_only !== true
      && comp?.ticket_price_trusted === true
      && String(comp?.ticket_price_currency || "").trim().toUpperCase() === "GBP"
    );
    const giveawayGuysBase = {
      ...base,
      perUserTicketLimit: giveawayGuysPerUserLimit,
    };
    if (comp?.odds_ready !== true || comp?.budget_odds_eligible !== true) {
      return {
        ...giveawayGuysBase,
        totalTicketCap: null,
        ticketCapReason: "giveawayguys_not_published_odds_ready",
      };
    }
    if (!trusted) {
      return {
        ...giveawayGuysBase,
        totalTicketCap: null,
        ticketCapReason: "giveawayguys_total_cap_unclear",
      };
    }
    if (giveawayGuysPerUserLimit != null && giveawayGuysPerUserLimit >= cap) {
      return {
        ...giveawayGuysBase,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_or_below_per_user_limit",
      };
    }
    return {
      totalTicketCap: cap,
      perUserTicketLimit: giveawayGuysPerUserLimit,
      ticketCapTrusted: true,
      ticketCapUnclear: false,
      ticketCapReason: "trusted_giveawayguys_total_ticket_cap",
    };
  }
  if (ukccRecord) {
    if (untrustedEvidence || untrustedUkccEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_source_is_purchase_limit",
      };
    }
    if (perUserLimit != null && cap === perUserLimit && !trustedUkccEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_per_user_limit",
      };
    }
    if (trustedUkccEvidence) {
      return {
        totalTicketCap: cap,
        perUserTicketLimit: perUserLimit,
        ticketCapTrusted: true,
        ticketCapUnclear: false,
        ticketCapReason: "trusted_ukcc_total_ticket_cap",
      };
    }
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "ukcc_total_cap_unclear",
    };
  }
  if (eliteRecord) {
    const eliteTrustedTotal = trustedEliteEvidence || explicitTotalCap;
    if ((untrustedEvidence || untrustedEliteEvidence) && !eliteTrustedTotal) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_source_is_purchase_limit",
      };
    }
    if (perUserLimit != null && cap === perUserLimit && !eliteTrustedTotal) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_per_user_limit",
      };
    }
    if (perUserLimit != null && cap === perUserLimit) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_per_user_limit",
      };
    }
    if (eliteTrustedTotal) {
      return {
        totalTicketCap: cap,
        perUserTicketLimit: perUserLimit,
        ticketCapTrusted: true,
        ticketCapUnclear: false,
        ticketCapReason: "trusted_elite_total_ticket_cap",
      };
    }
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "elite_total_cap_unclear",
    };
  }
  if (revCompsRecord) {
    if ((untrustedEvidence || untrustedRevCompsEvidence) && !trustedRevCompsEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_source_is_purchase_limit",
      };
    }
    if (perUserLimit != null && cap === perUserLimit && !trustedRevCompsEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_per_user_limit",
      };
    }
    if (trustedRevCompsEvidence) {
      return {
        totalTicketCap: cap,
        perUserTicketLimit: perUserLimit,
        ticketCapTrusted: true,
        ticketCapUnclear: false,
        ticketCapReason: "trusted_revcomps_total_ticket_cap",
      };
    }
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "revcomps_total_cap_unclear",
    };
  }
  if (sevendaysRecord) {
    if (comp?.odds_ready !== true || comp?.budget_odds_eligible !== true) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "sevendays_not_published_odds_ready",
      };
    }
    if ((untrustedEvidence || untrustedSevendaysEvidence) && !trustedSevendaysEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_source_is_purchase_limit",
      };
    }
    if (perUserLimit != null && cap === perUserLimit && !trustedSevendaysEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_per_user_limit",
      };
    }
    if (trustedSevendaysEvidence) {
      return {
        totalTicketCap: cap,
        perUserTicketLimit: perUserLimit,
        ticketCapTrusted: true,
        ticketCapUnclear: false,
        ticketCapReason: "trusted_sevendays_total_ticket_cap",
      };
    }
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "sevendays_total_cap_unclear",
    };
  }
  if (clickRecord) {
    if (comp?.odds_ready !== true || comp?.budget_odds_eligible !== true) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "click_not_published_odds_ready",
      };
    }
    if ((untrustedEvidence || untrustedClickEvidence) && !trustedClickEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_source_is_purchase_limit",
      };
    }
    if (perUserLimit != null && cap === perUserLimit && !trustedClickEvidence) {
      return {
        ...base,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_per_user_limit",
      };
    }
    if (trustedClickEvidence) {
      return {
        totalTicketCap: cap,
        perUserTicketLimit: perUserLimit,
        ticketCapTrusted: true,
        ticketCapUnclear: false,
        ticketCapReason: "trusted_click_total_ticket_cap",
      };
    }
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "click_total_cap_unclear",
    };
  }
  if (stormRecord) {
    const source = String(comp?.max_tickets_source || "").trim().toLowerCase();
    const stormPerUserLimit = positiveInt(comp?.per_user_limit) ?? perUserLimit;
    const trusted = Boolean(
      comp?.odds_ready === true
      && comp?.budget_odds_eligible === true
      && comp?.max_tickets_trusted === true
      && TRUSTED_STORM_TOTAL_CAP_SOURCES.includes(source)
      && trustedStormEvidence
      && !untrustedStormEvidence
      && String(comp?.max_tickets_evidence || "").trim()
      && String(comp?.storm_exact_identity || "").trim()
      && comp?.storm_standard_odds_supported === true
      && comp?.storm_awareness_only !== true
      && comp?.ticket_price_trusted === true
      && String(comp?.ticket_price_currency || "").trim().toUpperCase() === "GBP"
    );
    const stormBase = {
      ...base,
      perUserTicketLimit: stormPerUserLimit,
    };
    if (comp?.odds_ready !== true || comp?.budget_odds_eligible !== true) {
      return {
        ...stormBase,
        totalTicketCap: null,
        ticketCapReason: "storm_not_published_odds_ready",
      };
    }
    if (!trusted) {
      return {
        ...stormBase,
        totalTicketCap: null,
        ticketCapReason: "storm_total_cap_unclear",
      };
    }
    return {
      totalTicketCap: cap,
      perUserTicketLimit: stormPerUserLimit,
      ticketCapTrusted: true,
      ticketCapUnclear: false,
      ticketCapReason: "trusted_storm_total_ticket_cap",
    };
  }
  if (caddyRecord) {
    const source = String(comp?.max_tickets_source || "").trim().toLowerCase();
    const caddyPerUserLimit = positiveInt(comp?.per_user_limit) ?? perUserLimit;
    const trusted = Boolean(
      comp?.odds_ready === true
      && comp?.budget_odds_eligible === true
      && comp?.max_tickets_trusted === true
      && TRUSTED_CADDY_TOTAL_CAP_SOURCES.includes(source)
      && trustedCaddyEvidence
      && !untrustedCaddyEvidence
      && String(comp?.max_tickets_evidence || "").trim()
      && String(comp?.caddy_exact_identity || "").trim()
      && comp?.caddy_standard_odds_supported === true
      && comp?.caddy_awareness_only !== true
      && comp?.ticket_price_trusted === true
      && String(comp?.ticket_price_currency || "").trim().toUpperCase() === "GBP"
    );
    const caddyBase = {
      ...base,
      perUserTicketLimit: caddyPerUserLimit,
    };
    if (comp?.odds_ready !== true || comp?.budget_odds_eligible !== true) {
      return {
        ...caddyBase,
        totalTicketCap: null,
        ticketCapReason: "caddy_not_published_odds_ready",
      };
    }
    if (!trusted) {
      return {
        ...caddyBase,
        totalTicketCap: null,
        ticketCapReason: "caddy_total_cap_unclear",
      };
    }
    return {
      totalTicketCap: cap,
      perUserTicketLimit: caddyPerUserLimit,
      ticketCapTrusted: true,
      ticketCapUnclear: false,
      ticketCapReason: "trusted_caddy_total_ticket_cap",
    };
  }
  if (jammyRecord) {
    const source = String(comp?.max_tickets_source || "").trim().toLowerCase();
    const jammyPerUserLimit = positiveInt(comp?.per_user_limit) ?? perUserLimit;
    const trusted = Boolean(
      comp?.odds_ready === true
      && comp?.budget_odds_eligible === true
      && comp?.max_tickets_trusted === true
      && TRUSTED_JAMMY_TOTAL_CAP_SOURCES.includes(source)
      && trustedJammyEvidence
      && !untrustedJammyEvidence
      && String(comp?.max_tickets_evidence || "").trim()
      && String(comp?.jammy_exact_identity || "").trim()
      && comp?.jammy_standard_odds_supported === true
      && comp?.jammy_awareness_only !== true
      && comp?.ticket_price_trusted === true
      && String(comp?.ticket_price_currency || "").trim().toUpperCase() === "GBP"
    );
    const jammyBase = {
      ...base,
      perUserTicketLimit: jammyPerUserLimit,
    };
    if (comp?.odds_ready !== true || comp?.budget_odds_eligible !== true) {
      return {
        ...jammyBase,
        totalTicketCap: null,
        ticketCapReason: "jammy_not_published_odds_ready",
      };
    }
    if (!trusted) {
      return {
        ...jammyBase,
        totalTicketCap: null,
        ticketCapReason: "jammy_total_cap_unclear",
      };
    }
    if (jammyPerUserLimit != null && jammyPerUserLimit >= cap) {
      return {
        ...jammyBase,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_or_below_per_user_limit",
      };
    }
    return {
      totalTicketCap: cap,
      perUserTicketLimit: jammyPerUserLimit,
      ticketCapTrusted: true,
      ticketCapUnclear: false,
      ticketCapReason: "trusted_jammy_total_ticket_cap",
    };
  }
  if (prizeParadiseRecord) {
    const source = String(comp?.max_tickets_source || "").trim().toLowerCase();
    const prizeParadisePerUserLimit = positiveInt(comp?.per_user_limit) ?? perUserLimit;
    const trusted = Boolean(
      comp?.odds_ready === true
      && comp?.budget_odds_eligible === true
      && comp?.max_tickets_trusted === true
      && TRUSTED_PRIZEPARADISE_TOTAL_CAP_SOURCES.includes(source)
      && trustedPrizeParadiseEvidence
      && !untrustedPrizeParadiseEvidence
      && String(comp?.max_tickets_evidence || "").trim()
      && String(comp?.prizeparadise_exact_identity || "").trim()
      && comp?.prizeparadise_standard_odds_supported === true
      && comp?.prizeparadise_awareness_only !== true
      && comp?.ticket_price_trusted === true
      && String(comp?.ticket_price_currency || "").trim().toUpperCase() === "GBP"
    );
    const prizeParadiseBase = {
      ...base,
      perUserTicketLimit: prizeParadisePerUserLimit,
    };
    if (comp?.odds_ready !== true || comp?.budget_odds_eligible !== true) {
      return {
        ...prizeParadiseBase,
        totalTicketCap: null,
        ticketCapReason: "prizeparadise_not_published_odds_ready",
      };
    }
    if (!trusted) {
      return {
        ...prizeParadiseBase,
        totalTicketCap: null,
        ticketCapReason: "prizeparadise_total_cap_unclear",
      };
    }
    if (prizeParadisePerUserLimit != null && prizeParadisePerUserLimit >= cap) {
      return {
        ...prizeParadiseBase,
        totalTicketCap: null,
        ticketCapReason: "cap_matches_or_below_per_user_limit",
      };
    }
    return {
      totalTicketCap: cap,
      perUserTicketLimit: prizeParadisePerUserLimit,
      ticketCapTrusted: true,
      ticketCapUnclear: false,
      ticketCapReason: "trusted_prizeparadise_total_ticket_cap",
    };
  }
  if (brightRecord) {
    const source = String(comp?.max_tickets_source || "").trim().toLowerCase();
    const brightPerUserLimit = positiveInt(comp?.per_user_limit) ?? perUserLimit;
    const trustedBrightEvidence = hasMarker(evidence, TRUSTED_BRIGHT_TOTAL_CAP_SOURCES);
    const trusted = Boolean(
      comp?.odds_ready === true
      && comp?.budget_odds_eligible === true
      && comp?.max_tickets_trusted === true
      && TRUSTED_BRIGHT_TOTAL_CAP_SOURCES.includes(source)
      && trustedBrightEvidence
      && !untrustedBrightEvidence
      && String(comp?.max_tickets_evidence || "").trim()
      && String(comp?.bright_exact_identity || "").trim()
      && comp?.bright_standard_odds_supported === true
      && comp?.bright_awareness_only !== true
      && comp?.ticket_price_trusted === true
      && String(comp?.ticket_price_currency || "").trim().toUpperCase() === "GBP"
    );
    const brightBase = {
      ...base,
      perUserTicketLimit: brightPerUserLimit,
    };
    if (comp?.odds_ready !== true || comp?.budget_odds_eligible !== true) {
      return {
        ...brightBase,
        totalTicketCap: null,
        ticketCapReason: "bright_not_published_odds_ready",
      };
    }
    if (!trusted) {
      return {
        ...brightBase,
        totalTicketCap: null,
        ticketCapReason: "bright_total_cap_unclear",
      };
    }
    return {
      totalTicketCap: cap,
      perUserTicketLimit: brightPerUserLimit,
      ticketCapTrusted: true,
      ticketCapUnclear: false,
      ticketCapReason: "trusted_bright_total_ticket_cap",
    };
  }
  if (hotcompsRecord) {
    const source = String(comp?.max_tickets_source || "").trim().toLowerCase();
    const hotcompsPerUserLimit = positiveInt(comp?.per_user_limit) ?? perUserLimit;
    const trusted = Boolean(
      comp?.odds_ready === true
      && comp?.budget_odds_eligible === true
      && comp?.max_tickets_trusted === true
      && TRUSTED_HOTCOMPS_TOTAL_CAP_SOURCES.includes(source)
      && trustedHotCompsEvidence
      && !untrustedHotCompsEvidence
      && String(comp?.max_tickets_evidence || "").trim()
      && String(comp?.hotcomps_exact_identity || "").trim()
      && comp?.hotcomps_standard_odds_supported === true
      && comp?.hotcomps_awareness_only !== true
      && comp?.ticket_price_trusted === true
      && String(comp?.ticket_price_currency || "").trim().toUpperCase() === "GBP"
    );
    const hotcompsBase = {
      ...base,
      perUserTicketLimit: hotcompsPerUserLimit,
    };
    if (comp?.odds_ready !== true || comp?.budget_odds_eligible !== true) {
      return {
        ...hotcompsBase,
        totalTicketCap: null,
        ticketCapReason: "hotcomps_not_published_odds_ready",
      };
    }
    if (!trusted) {
      return {
        ...hotcompsBase,
        totalTicketCap: null,
        ticketCapReason: "hotcomps_total_cap_unclear",
      };
    }
    return {
      totalTicketCap: cap,
      perUserTicketLimit: hotcompsPerUserLimit,
      ticketCapTrusted: true,
      ticketCapUnclear: false,
      ticketCapReason: "trusted_hotcomps_total_ticket_cap",
    };
  }
  if (thatprizeguyRecord) {
    const source = String(comp?.max_tickets_source || "").trim().toLowerCase();
    const thatprizeguyPerUserLimit = positiveInt(comp?.per_user_limit) ?? perUserLimit;
    const trusted = Boolean(
      comp?.odds_ready === true
      && comp?.budget_odds_eligible === true
      && comp?.max_tickets_trusted === true
      && TRUSTED_THATPRIZEGUY_TOTAL_CAP_SOURCES.includes(source)
      && trustedThatPrizeGuyEvidence
      && !untrustedThatPrizeGuyEvidence
      && String(comp?.max_tickets_evidence || "").trim()
      && String(comp?.thatprizeguy_exact_identity || "").trim()
      && comp?.thatprizeguy_standard_odds_supported === true
      && comp?.thatprizeguy_awareness_only !== true
      && comp?.ticket_price_trusted === true
      && String(comp?.ticket_price_currency || "").trim().toUpperCase() === "GBP"
    );
    const thatprizeguyBase = {
      ...base,
      perUserTicketLimit: thatprizeguyPerUserLimit,
    };
    if (comp?.odds_ready !== true || comp?.budget_odds_eligible !== true) {
      return {
        ...thatprizeguyBase,
        totalTicketCap: null,
        ticketCapReason: "thatprizeguy_not_published_odds_ready",
      };
    }
    if (!trusted) {
      return {
        ...thatprizeguyBase,
        totalTicketCap: null,
        ticketCapReason: "thatprizeguy_total_cap_unclear",
      };
    }
    return {
      totalTicketCap: cap,
      perUserTicketLimit: thatprizeguyPerUserLimit,
      ticketCapTrusted: true,
      ticketCapUnclear: false,
      ticketCapReason: "trusted_thatprizeguy_total_ticket_cap",
    };
  }
  if (salexmoRecord) {
    const source = String(comp?.max_tickets_source || "").trim().toLowerCase();
    const salexmoPerUserLimit = positiveInt(comp?.per_user_limit) ?? perUserLimit;
    const trusted = Boolean(
      comp?.odds_ready === true
      && comp?.budget_odds_eligible === true
      && comp?.max_tickets_trusted === true
      && TRUSTED_SALEXMO_TOTAL_CAP_SOURCES.includes(source)
      && trustedSalexmoEvidence
      && !untrustedSalexmoEvidence
      && String(comp?.max_tickets_evidence || "").trim()
      && String(comp?.salexmo_exact_identity || "").trim()
      && comp?.salexmo_standard_odds_supported === true
      && comp?.salexmo_awareness_only !== true
      && comp?.ticket_price_trusted === true
      && String(comp?.ticket_price_currency || "").trim().toUpperCase() === "GBP"
    );
    const salexmoBase = {
      ...base,
      perUserTicketLimit: salexmoPerUserLimit,
    };
    if (comp?.odds_ready !== true || comp?.budget_odds_eligible !== true) {
      return {
        ...salexmoBase,
        totalTicketCap: null,
        ticketCapReason: "salexmo_not_published_odds_ready",
      };
    }
    if (!trusted) {
      return {
        ...salexmoBase,
        totalTicketCap: null,
        ticketCapReason: "salexmo_total_cap_unclear",
      };
    }
    return {
      totalTicketCap: cap,
      perUserTicketLimit: salexmoPerUserLimit,
      ticketCapTrusted: true,
      ticketCapUnclear: false,
      ticketCapReason: "trusted_salexmo_total_ticket_cap",
    };
  }
  if (untrustedEvidence) {
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "cap_source_is_purchase_limit",
    };
  }
  if (perUserLimit != null && cap === perUserLimit && !trustedEvidence) {
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "cap_matches_per_user_limit",
    };
  }
  if (!(trustedEvidence || explicitTotalCap || dcgV2Record || availabilityBackedTotal)) {
    return {
      ...base,
      totalTicketCap: null,
      ticketCapReason: "cap_source_unconfirmed",
    };
  }
  return {
    totalTicketCap: cap,
    perUserTicketLimit: perUserLimit,
    ticketCapTrusted: true,
    ticketCapUnclear: false,
    ticketCapReason: "trusted_total_ticket_cap",
  };
};

export const hasTrustedTotalTicketCap = (comp = {}) =>
  Boolean(totalTicketCapInfo(comp).totalTicketCap);

export const computeBudgetOddsView = (comp = {}, budget = 0) => {
  const ticketPrice = positiveNumber(comp?.current_unit_ticket_price ?? comp?.ticket_price);
  const capInfo = totalTicketCapInfo(comp);
  const numericBudget = Math.max(0, Number(budget) || 0);
  const base = {
    ok: false,
    tickets: null,
    budgetTicketCount: 0,
    effectiveUserTicketCount: 0,
    cappedByUserLimit: false,
    oddsText: "Odds unavailable",
    totalTicketCap: capInfo.totalTicketCap,
    ticketCapReason: capInfo.ticketCapReason,
    ticketCapUnclear: capInfo.ticketCapUnclear,
    perUserTicketLimit: capInfo.perUserTicketLimit,
  };

  if (comp?.free_entry_competition === true) {
    return {
      ...base,
      reason: "Budget Odds unavailable: this is a free-entry competition.",
    };
  }

  if (comp?.budget_odds_eligible === false) {
    const reasons = {
      missing_trusted_ticket_price: "Budget Odds unavailable: trusted live ticket price is missing.",
      missing_max_tickets: "Odds unavailable: total ticket cap unclear.",
      unsupported_category: "Budget Odds unavailable for this category.",
      closed_or_expired: "Budget Odds unavailable: this competition is closed or expired.",
      not_verified_public: "Budget Odds unavailable: the competition is not verified for public odds.",
      missing_source_evidence: "Budget Odds unavailable: source evidence is incomplete.",
    };
    return {
      ...base,
      reason: reasons[comp?.budget_odds_missing_reason] || "Budget Odds unavailable: this competition is not eligible.",
    };
  }

  if (ticketPrice == null) {
    return {
      ...base,
      reason: "Budget Odds unavailable: ticket price is not set.",
    };
  }

  const baseTicketCount = Math.floor(numericBudget / ticketPrice);
  let budgetTicketCount = baseTicketCount;
  let effectiveUnitPriceForBudget = ticketPrice;
  let bulkDiscountApplied = false;
  let bulkDiscountEvidence = null;
  for (const tier of comp?.bulk_discount_tiers || []) {
    if (!tier || typeof tier !== "object") continue;
    const quantity = positiveInt(tier.quantity ?? tier.entries ?? tier.tickets);
    let totalPrice = positiveNumber(tier.total_price ?? tier.bundle_price);
    const unitPrice = positiveNumber(tier.unit_price);
    if (totalPrice == null && quantity && unitPrice) totalPrice = quantity * unitPrice;
    const evidence = String(tier.evidence ?? tier.bulk_discount_evidence ?? "").trim();
    const source = String(tier.source ?? "").toLowerCase();
    const trusted = tier.trusted === true || (
      Boolean(evidence) && ["detail", "api", "operator", "explicit"].some((marker) => source.includes(marker))
    );
    if (!trusted || !quantity || !totalPrice || totalPrice > numericBudget) continue;
    const bundles = Math.floor(numericBudget / totalPrice);
    const remainder = Math.max(0, numericBudget - bundles * totalPrice);
    const candidateCount = bundles * quantity + Math.floor(remainder / ticketPrice);
    if (candidateCount > budgetTicketCount) {
      budgetTicketCount = candidateCount;
      effectiveUnitPriceForBudget = totalPrice / quantity;
      bulkDiscountApplied = true;
      bulkDiscountEvidence = evidence || null;
    }
  }
  let effectiveTickets = budgetTicketCount;
  let cappedByUserLimit = false;
  if (capInfo.perUserTicketLimit && effectiveTickets > capInfo.perUserTicketLimit) {
    effectiveTickets = capInfo.perUserTicketLimit;
    cappedByUserLimit = true;
  }

  const withTickets = {
    ...base,
    tickets: effectiveTickets,
    budgetTicketCount,
    effectiveUserTicketCount: effectiveTickets,
    cappedByUserLimit,
    effectiveUnitPriceForBudget,
    maxAffordableEntriesForBudget: budgetTicketCount,
    bulkDiscountApplied,
    bulkDiscountEvidence,
  };

  if (effectiveTickets <= 0) {
    return {
      ...withTickets,
      reason: `Your \u00a3${numericBudget} is below the ticket price (\u00a3${ticketPrice.toFixed(2)}).`,
    };
  }

  if (!capInfo.totalTicketCap) {
    return {
      ...withTickets,
      reason: "Odds unavailable: total ticket cap unclear.",
    };
  }

  const denom = Math.max(1, Math.round(capInfo.totalTicketCap / effectiveTickets));
  return {
    ...withTickets,
    ok: true,
    oddsText: `1 in ${denom.toLocaleString("en-GB")}`,
  };
};
